import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }
const _hoisted_2 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = { class: "relative items-center py-4" }
const _hoisted_5 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_6 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_override_confirm = _resolveComponent("override-confirm")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isAssignModalOpened,
    "no-padding": true,
    title: _ctx.$t('Sensors.AssignTitle', { mac: _ctx.sensor.mac }),
    onToggleModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      (_ctx.isOverrideModalOpened)
        ? (_openBlock(), _createBlock(_component_override_confirm, {
            key: 0,
            "is-override-modal-opened": _ctx.isOverrideModalOpened,
            onToggleModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOverrideModalOpened = false)),
            onOverrideAction: _ctx.handleOverride
          }, null, 8, ["is-override-modal-opened", "onOverrideAction"]))
        : _createCommentVNode("", true),
      _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("Sensors.Space")), 1),
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isParkingSpaceListLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.assign.spaceId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.assign.spaceId) = $event)),
                          class: _normalizeClass(`mt-1 w-full`),
                          options: _ctx.parkingSpaces,
                          reduce: (space) => space.id,
                          label: "name"
                        }, null, 8, ["modelValue", "options", "reduce"]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Sensors.ParkingSpotType")), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.isParkingSpotTypesListLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.assign.spotTypeId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.assign.spotTypeId) = $event)),
                          class: _normalizeClass(`mt-1 w-full`),
                          options: _ctx.parkingSpotTypes,
                          reduce: (space) => space.id,
                          label: "name"
                        }, null, 8, ["modelValue", "options", "reduce"]))
                  ])
                ]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.assign.index,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.assign.index) = $event)),
                  label: _ctx.$t('Sensors.Index'),
                  type: "number"
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-displayed", "title"]))
}